import { ModalityType, type Modality } from '@littlebird/sdk';
import {
  EDIT_TOOL_TYPES as EDIT_TOOL_TYPE_STRINGS,
  filterDisplayableModalities as filterDisplayableModalitiesBase,
} from '@littlebird/ui-utils';

import { isProd } from '@/env';

export const EDIT_TOOL_TYPES = EDIT_TOOL_TYPE_STRINGS as ReadonlySet<
  typeof EDIT_TOOL_TYPE_STRINGS extends Iterable<infer T> ? T : never
>;

export {
  extractLatestTodoWriteItems,
  getDomain,
  getEditToolChips,
  getIntegrationToolName,
  getModalityDescription,
  getModalityTitle,
  getStaticTodoWriteItems,
  getStepTitle,
  getTodoWriteSummary,
  getUserContextChipGroups,
  getWebSearchQueries,
  getWorkingWord,
  integrationNameFromSlug,
  isContentOldEnough,
  isSelfToolExecute,
  normalizeIntegrationName,
} from '@littlebird/ui-utils';

// TodoWrite is filtered globally for desktop because the only surface that
// renders the canonical `MessageList` (Thread.tsx) also mounts the
// `TodoPlanPanel` above the composer. If you add a new surface that renders
// `MessageList` without `TodoPlanPanel`, also mount the panel there or
// branch this filter so TodoWrite doesn't disappear silently.
export function filterDisplayableModalities(
  modalities: Modality[] | null | undefined
): Modality[] {
  const base = filterDisplayableModalitiesBase(modalities, {
    showSelfKnowledge: !isProd,
  }) as Modality[];
  return base.filter((modality) => modality.type !== ModalityType.TodoWrite);
}
